export default "__VITE_ASSET__B_Cp5AZP__"